module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/handcash-logo-5e9ef81bd33d2c9b.png"+" 512w",
        images: [{path: __webpack_public_path__ + "assets/images/handcash-logo-5e9ef81bd33d2c9b.png",width: 512,height: 512}],
        src: __webpack_public_path__ + "assets/images/handcash-logo-5e9ef81bd33d2c9b.png",
        toString: function(){return __webpack_public_path__ + "assets/images/handcash-logo-5e9ef81bd33d2c9b.png"},
        
        width: 512,
        height: 512
      }